import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { ThemeContext } from "../../context";
import { themes } from "../../styles/themes";

const ThemeStyles = styled.div`
  ${({ theme }) => theme}
`;

const Theme = ({ children }) => {
  const { theme } = useContext(ThemeContext);
  return <ThemeStyles theme={themes[theme]}>{children}</ThemeStyles>;
};

Theme.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Theme;
